import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { NotifyUsersInput } from './notify-users-input';
import { NotifyUsersService } from 'src/app/services/notify-users/notify-users.service';
import { ConfirmationModalComponent } from 'src/app/shared/common-components/confirmation-modal/confirmation-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UserService } from 'src/app/services/user/user.service';
import AppConstants from 'src/app/shared/common-components/AppConstants';


@Component({
    selector: 'app-notify-users',
    templateUrl: './notify-users.component.html',
    styleUrls: ['./notify-users.component.css'],
    standalone: false
})

export class NotifyUsersComponent implements OnInit {
  notifyUsersForm : UntypedFormGroup;
  busType : string;
  usersType: string;
  usersSubType: string;
  apprType: string[];
  rfspInclude: boolean;
  uploadImage: boolean;
  organizationid: Number = -1;
  permission: string = "";
  notifyUsersin: NotifyUsersInput;
  uploadedFilesList: any[];
  uploadedFiles: any[];
  uploadedFilesSizes: any[];
  exceededUploadLimit: boolean;
  withinUploadLimit: boolean;
  fileCount: any;
  uploadLimit: number;
  sentEmails: boolean;
  images : any[];
  banner : any;
  modalRef: BsModalRef;
  constructor(private router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private notifyUsersService: NotifyUsersService,
    private userService: UserService,
    private tmssLoader: LoadingService,
    private modalService: BsModalService) {
    
   }

  ngOnInit(): void {
    this.tmssLoader.show();
    this.getUserDetails();
    this.busType = '';
    this.usersType = '';
    this.usersSubType = '';
    this.apprType = [];
    this.rfspInclude = false;
    this.exceededUploadLimit = false;
    this.withinUploadLimit = false;
    this.sentEmails = false;
    this.uploadImage = false;

    this.createForm();
    this.notifyUsersForm.get('bannerImage').setValue('TMSS_logo.gif');
    this.tmssLoader.hide();
  }

  getUserDetails() {
      this.userService.getCurrentUserDetails().subscribe((currentUser) => {
        if (AppConstants.isNotNullCondition(currentUser)) {
          this.organizationid = currentUser.organizationId
            ? currentUser.organizationId
            : -1;
          this.permission = currentUser.permissions;
        }
      });
    }

  createForm(){
    this.notifyUsersForm = this.fb.group({
      busType : new UntypedFormControl(''),
      usersType : new UntypedFormControl('',[Validators.required]),
      usersSubType : new UntypedFormControl('',[Validators.required]),
      apprType : new UntypedFormControl('All Approval Types'),
      rfspInclude : [false],
      emailSubject : new UntypedFormControl('',[Validators.required]),
      bannerImage: new UntypedFormControl(''),
      emailBody : new UntypedFormControl('',[Validators.required]),
      uploadImage : [false]
    })
  }
  businessTypeChange(event: any){
    this.busType = event;
    /* this.notifyUsersService.listOfImages(this.busType)
       .subscribe(images => {this.images = images});
    */
    this.initAfterBusTypeChange();

  }
  usersTypeChange(event: any){
    this.usersType = event;
    this.initAfterUsersTypeChange();
  }
  userSubTypeChange(event: any){
    this.usersSubType = event;
    this.initAfterUsersSubTypeChange();
  }
  apprTypeChange(event: any){
    this.apprType = (JSON.parse(JSON.stringify(this.notifyUsersForm.value)).apprType);;
    //console.log(this.apprType);
  }
  rfspChange(event: any){
    this.rfspChange = event;
  }
  rfspIncludeCheck(event){
    this.rfspInclude = event.target.checked;
  }
  bannerImageChange(event: any){
    this.banner = event;
    console.log(this.banner);
  }
  gotResponseFromUploadImage(uploadImageResponse : boolean){
    console.log("got response from upload image component:" + uploadImageResponse);
    if(uploadImageResponse){
      this.uploadImage = false;
      this.notifyUsersForm.get('uploadImage').setValue(false);
      this.notifyUsersService.listOfImages(this.permission)
       .subscribe(images => {this.images = images});
    }
  }
  updateUploadedFiles(filesList : any){
    this.uploadedFiles = filesList;
    this.uploadedFilesList = [];
    this.uploadedFilesSizes = [];
    this.exceededUploadLimit = false;
    this.withinUploadLimit = false;
    this.uploadLimit = 0.0;
    this.sentEmails = false;
    let j = 0;
    for(let i = 0; i < this.uploadedFiles.length; i++) {
      let myArr = this.uploadedFiles[i].split('~%');
      this.uploadedFilesList.push(myArr[0]);
      this.uploadedFilesSizes.push(myArr[1]);  
      this.uploadLimit += +myArr[1];
      this.withinUploadLimit = true;
      this.fileCount = ++j;
    } 
    if (this.uploadLimit > 40.00){
      this.exceededUploadLimit = true;
      this.withinUploadLimit = false;
    }
    this.uploadLimit = +this.uploadLimit.toFixed(3);
  }
  submit(){
    this.notifyUsersin = new NotifyUsersInput();
    this.notifyUsersin.busType = this.permission;
    this.notifyUsersin.usersType = this.notifyUsersForm.get('usersType').value;
    this.notifyUsersin.usersSubType = this.notifyUsersForm.get('usersSubType').value;
   // this.notifyUsersin.apprType = this.notifyUsersForm.get('apprType').value;
    this.notifyUsersin.apprType = this.apprType;
    this.notifyUsersin.includeRfsps = this.notifyUsersForm.get('rfspInclude').value;
    this.notifyUsersin.emailSubject = this.notifyUsersForm.get('emailSubject').value;
    this.notifyUsersin.banner = this.notifyUsersForm.get('bannerImage').value;
    this.notifyUsersin.emailBody = this.notifyUsersForm.get('emailBody').value;
    this.notifyUsersin.attachments = this.uploadedFilesList;
    this.uploadedFilesList = null;
    this.withinUploadLimit = false;
    //console.log(this.notifyUsersin);
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to send out the email?';
      this.modalRef.content.title = 'Notify User';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.tmssLoader.show();
          this.notifyUsersService.sendEmails(this.notifyUsersin)
            .subscribe(result =>{
            this.alertService.success("Emails are being sent out");
            this.resetScreen();
            this.sentEmails = true;
            this.tmssLoader.hide();
          },
          error => {
            console.log(error);
            console.log("error in sending out emails");
            this.alertService.error("error while trying to send out emails");
            this.tmssLoader.hide();
          });
        }
      });
  }

  resetScreen(){
    this.notifyUsersForm.get('busType').setValue('');
    this.notifyUsersForm.get('bannerImage').setValue('TMSS_logo');
    this.notifyUsersForm.get('uploadImage').setValue(false);
    this.uploadImage = false;
    this.busType ='';
    this.images = [];
    this.initAfterBusTypeChange();
  }
  initAfterBusTypeChange(){
    this.notifyUsersForm.get('usersType').setValue('');
    this.initAfterUsersTypeChange();
  }

  initAfterUsersTypeChange(){
    this.notifyUsersForm.get('usersSubType').setValue('');
    this.initAfterUsersSubTypeChange();
  }

  initAfterUsersSubTypeChange(){
    this.notifyUsersForm.get('apprType').setValue('All Approval Types');
    this.notifyUsersForm.get('rfspInclude').setValue(false);
    this.notifyUsersForm.get('emailSubject').setValue(null);
    this.notifyUsersForm.get('emailBody').setValue(null);
    this.notifyUsersForm.get('uploadImage').setValue(false);
  }
  uploadImageCheck(event){
    this.uploadImage = event.target.checked;
  }
 
}
